import barba from '@barba/core';

import {init_home_slider, desinit_home_slider} from "../home/slider";
import {image_trail_init, image_trail_desinit} from "../miscellaneous/imageTrail"
import {homeAnimationEnter, homeAnimationOnce, homeAnimationLeave} from "./animations/home"
import {contactAnimationOnce, contactAnimationEnter, contactAnimationLeave} from "./animations/contact"
import {defaultAnimationEnter, defaultAnimationLeave, defaultAnimationOnce} from "./animations/default"

import {default as cookie_law_init} from "../cookie/cookie_law"

import {big_title_init, create_split_text_for_disappead as big_title_split_text_for_disappead} from "../miscellaneous/bigTitle"
import {init as navigation_init} from "../navigation/navigation";
import {init_scroll_scrub, desinit_scroll_scrub} from "../scroller_content/scroller_scrub"


/**
 * Entering in view : scroll top
 */
window.onload = () => {

    barba.hooks.once((data) => {
        console.log('Global hook Once')
        image_trail_init(data.next.container);

        $(document).ready(function(){
            console.info("%c Création graphique : Zeecom %c ⟹ https://www.zeecom.fr", "font-family: Gill Sans, sans-serif;font-size:16px; background:#f7f3f0; color:#00216b", "background:none");
            console.info("%c Développement : Aurélien Chappard - Deefuse %c ⟹ https://www.deefuse.fr", "font-family: Gill Sans, sans-serif;font-size:16px; background:#f7f3f0; color:#00216b", "background:none");

            navigation_init();
            cookie_law_init();
            $(this).scrollTop(0);

            $('.accordion .card .card-header button').on('click', function (e){
                e.preventDefault();
                console.log('collapse at once');
                $($(this).data('target')).collapse('toggle');
            });
            /*$(window).on('beforeunload', function(){
                $('body').hide();
                $(window).scrollTop(0);
            });*/
           // image_trail_init(data.next.container);
        });
    });

    barba.hooks.beforeEnter((data) => {
       // console.log('Global hook beforeenter')
        // console.log(data.next.container);;
        // Scroll to the top position when enter animation

    })

    barba.hooks.afterLeave((data) => {
        image_trail_desinit(data.current.container);
        $('.collapse').collapse('dispose');
        window.scrollTo(0,0);
    })



    barba.hooks.after((data) => {
        console.log('Global hook AFTER')
        image_trail_init(data.next.container);

        $('.accordion .card .card-header button').on('click', function (e){
            e.preventDefault();
            console.log('collapse at after');
            $($(this).data('target')).collapse('toggle');
        });
    })



    barba.init({
        //debug: true,
        timeout: 5000,
        views: [
            {
                namespace: "front-page",
                beforeEnter(){
                    big_title_init(true);
                },
                beforeLeave(){
                    big_title_split_text_for_disappead(true);
                },
                afterLeave(){
                    desinit_home_slider();
                }
            },
            {
                namespace: "page",
                beforeEnter(){
                    // console.log("BEFORE ENTER A PAGE");
                    big_title_init(true);
                },
                beforeLeave(){
                    big_title_split_text_for_disappead(true);
                },
            },
            {
                namespace: "contact",
                beforeEnter(){
                    // console.log("BEFORE ENTER A CONTACT PAGE");
                    big_title_init(true);
                },
                beforeLeave(){
                    big_title_split_text_for_disappead(true);
                },
            },
            {
                namespace: "project",
                beforeEnter(data){
                    // console.log("BEFORE ENTER A project PAGE");
                    big_title_init(false);
                    init_scroll_scrub(data.next.container);

                },
                // afterEnter(data) {
                //     console.log("after enter project");
                //     console.log(data.next.container);
                // },
                beforeLeave(){
                    //console.log("BEFORE LEAVING A PROJECT");
                    big_title_split_text_for_disappead(false);
                    desinit_scroll_scrub();
                },
            },
        ],
        transitions: [
            // Animation spéciale pour décharger la home
            /**
             * Animation concernant la page d'accueil
             */
            {
                name: 'from-front-page',
                from: {
                    namespace: [
                        'front-page'
                    ]
                },
                leave : ({current}) => (homeAnimationLeave(current.container)),
                enter({next}) {
                    defaultAnimationEnter(next.container);
                },
            },
            {
                name: 'to-front-page',
                to: {
                    namespace: [
                        'front-page'
                    ]
                },
                once({next}) {
                    homeAnimationOnce(next.container);
                },
                enter({next}) {
                    homeAnimationEnter(next.container);
                },
                leave : ({current}) => (defaultAnimationLeave(current.container)),
            },
            {
                name: 'to-contact',
                to :{
                    namespace: ['contact']
                },
                from :{
                  namespace: ['page', 'project']
                },
                enter({next}) {
                    console.log("enter contact");
                    contactAnimationEnter(next.container);
                },
                leave : ({current}) => (defaultAnimationLeave(current.container)),
            },
            {
                name: 'to-contact-from-home',
                to :{
                    namespace: ['contact']
                },
                from :{
                  namespace: ['front-page']
                },
                enter({next}) {
                    contactAnimationEnter(next.container);
                },
                leave : ({current}) => (homeAnimationLeave(current.container)),
            },
            {
                name: 'general-transition',
                once({next}) {
                    defaultAnimationOnce(next.container);
                },
                leave : ({current}) => (defaultAnimationLeave(current.container)),
                enter({next}) {
                    defaultAnimationEnter(next.container);
                },
            },
        ]
    })

}

